import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
const StoreSkeleton = ({ sx, width, height }) => {
    return (
        <Box sx={{ minWidth:width, height: height, ...sx }}>
            <Skeleton sx={{ width: width, height: height }} variant="rectangular" animation="wave" />
        </Box>
    );
};

export default StoreSkeleton;
